import React from 'react';

import { makeStyles } from '@mui/styles';

import SelectBase from '../../../../workflows/primeX-underwriter/components/footer/SelectBase';

export const SingleSelect = ({
  onChange,
  options = [],
  value,
  disabled = false,
  name = '',
}: any) => {
  const classes = useClasses();

  const formattedOptions = React.useMemo(() => {
    if (options[0] && typeof options[0] === 'string') {
      return options.map((option: string) => ({
        label: option,
        value: option,
      }));
    }

    return options.map((questionField) => ({
      label: questionField.text,
      value: questionField.value,
    }));
  }, [options]);

  return (
    <SelectBase
      name={name}
      options={formattedOptions}
      onChange={onChange}
      classes={classes}
      disabled={disabled}
      value={value}
    />
  );
};

const useClasses = makeStyles(({ palette }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: palette.background.modal,
    border: 'none',
    '&:focus': {
      backgroundColor: palette.background.modal,
    },
  },
  selectedInputBase: {
    background: palette.background.details,
    borderRadius: 6,
    backgroundColor: palette.background.modal,
  },
  disabled: {
    color: `${palette.primary.contrastText} !important`,
    backgroundColor: palette.background.modal,
  },
}));
